import type { ResultsScore, Score } from '../pages/material/results/api/results';
import { SCORE_STATUS } from '../constants/ScoreStatus';
import { Medialink } from '../api/medialink';

export type Result = Score & {
  memberId: string;
  nodeId: string;
};

export type Status = typeof SCORE_STATUS[keyof typeof SCORE_STATUS];

export const getStatusLabel = (status: Status) => {
  return `PAGES.RESULTS.PROGRESS_BAR.STATUS.${status.toUpperCase()}.A11Y_LABEL`;
};

export const getResultPercentages = (score?: ResultsScore, needsGrading?: boolean) => {
  if (!score) return { awaiting: 0, success: 0, failure: 0, undone: 100 };

  if (needsGrading) return { awaiting: 100, success: 0, failure: 0, undone: 0 };

  return {
    awaiting: 0,
    success: score.achieved,
    failure: score.achievable - score.achieved,
    undone: score.maximum - score.achievable,
  };
};

export const getShowScore = (medialink: Medialink): boolean => {
  const showScore =
    medialink?.assessmentQExercise?.showScore ||
    medialink?.eduhintExercise?.showScore ||
    medialink?.edumaticExercise?.showScore;

  return Boolean(showScore);
};

export const isQuantifiable = ({
  score,
  unachievable = false,
  status,
}: {
  score?: Pick<ResultsScore, 'achieved'>;
  unachievable?: boolean;
  status?: string;
}): boolean => {
  return score === undefined || ((!unachievable || status === 'finished') && score.achieved !== -1);
};

export const formatDuration = (seconds: number): string => {
  if (seconds === 0) return '';
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  }

  const hours = Math.floor(seconds / 3600);
  const remainingMinutes = Math.floor((seconds % 3600) / 60);
  return `${hours}h ${remainingMinutes}m`;
};
